import React from 'react';
import ReactDOM from 'react-dom/client';

import {
  ChakraProvider
} from '@chakra-ui/react';

import {
  RouterProvider
} from 'react-router-dom';

import { router } from './routes';

import { theme } from './theme/theme';

ReactDOM.createRoot(
  document.getElementById('root')!
).render(

  <React.StrictMode>

    <ChakraProvider theme={theme}>

      <RouterProvider router={router} />

    </ChakraProvider>

  </React.StrictMode>
);